/* eslint-disable */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Column } from 'primereact/column';
import { TreeTable } from 'primereact/treetable';
import { Card } from "primereact/card";
import { SplitButton } from 'primereact/splitbutton';
import { Button as PrimeButton } from 'primereact/button';
import { Button as ReactButton } from 'react-bootstrap';
import { Col, Modal, Form, Row } from 'react-bootstrap';
import { InputText } from "primereact/inputtext";
import 'primereact/resources/themes/nova-accent/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import { handleRequest } from '../../redux/config/env';
import { ContextMenu } from 'primereact/contextmenu';
import $ from 'jquery';
import { Toast } from 'primereact/toast';

export class StockGroup extends Component {

    constructor() {
        super();
        this.state = {
            nodes: [],
            expandedKeys: {},
            addModal: false,
            addModal2:false,
            deleteModal: false,
            editModal: false,
            stockGroupId: null,
            stockGroupParentId: null,
            modalMaterialChildTypeName: "",
            modalMaterialParentTypeName:"",
            modalEditStockGroupName: "",
            rootStockGroupName: "",
            selectedNodeKey: null,
            globalFilter: null,
            splitButtonMenu: [
                {
                    label: 'Add',
                    icon: 'pi pi-fw pi-file',
                    items: [
                        {
                            label: 'Child',
                            icon: 'pi pi-fw pi-plus',
                            command: () => {
                                this.addChildStockGroup();
                            }
                        },
                        {
                            label: 'Parent',
                            icon: 'pi pi-fw pi-plus',
                            command: () => {
                                this.addParentStockGroup();
                            }
                        }
                    ]
                }, 
                {
                    label: 'Edit',
                    icon: 'pi pi-fw pi-pencil',
                    command: () => {
                        this.editStockGroup();
                    }
                },
                {
                    label: 'Delete',
                    icon: 'pi pi-fw pi-trash',
                    command: () => {
                        this.deleteStockGroup();
                    }
                },
                {
                    label: 'Toggle',
                    icon: 'pi pi-fw pi-angle-double-right',
                    command: () => {
                        this.toggleStockGroup();
                    }
                }
            ],
            splitButtonMenu2: [
                {
                label: 'Add',
                icon: 'pi pi-fw pi-file',
                items: [
                    {
                        label: 'Child',
                        icon: 'pi pi-fw pi-plus',
                        command: () => {
                            this.addChildStockGroup();
                        }
                    },
                    {
                        label: 'Parent',
                        icon: 'pi pi-fw pi-plus',
                        command: () => {
                            this.addParentStockGroup();
                        }
                    }
                  ]   
                }, 
                {
                    label: 'Edit',
                    icon: 'pi pi-fw pi-pencil',
                    command: () => {
                        this.editStockGroup();
                    }
                },
                {
                    label: 'Delete',
                    icon: 'pi pi-fw pi-trash',
                    command: () => {
                        this.deleteStockGroup();
                    }
                },
                {
                    label: 'Toggle',
                    icon: 'pi pi-fw pi-angle-double-right',
                    command: () => {
                        this.toggleStockGroup();
                    }
                }
            ]
        };

        this.actionTemplate = this.actionTemplate.bind(this);
    }

    componentDidMount = async () => {
        const response = await handleRequest("GET", "/StockGroup/getNodes");

        if (response.data.length === 0) {
            this.setState({
                nodes: []
            });
        }

        if (response.data.length !== 0) {
            this.setState({
                nodes: response.data
            });
        }

        document.addEventListener('contextmenu', this._handleContextMenu);
    }

    _handleContextMenu = (event) => {
        event.preventDefault();
        setTimeout(function () {
            $(".p-contextmenu").css("left", event.clientX - 264 + "px");
            $(".p-contextmenu").css("top", event.clientY - 141 + "px");
        }, 50);
    }

    restartTable = async () => {
        const response = await handleRequest("GET", "/StockGroup/getNodes");

        if (response.data.length === 0) {
            this.setState({
                nodes: []
            });
        }

        if (response.data.length !== 0) {
            this.setState({
                nodes: response.data
            });
        }
    }

    actionTemplate(rowData, column) { 
        return <SplitButton type="button" icon="pi pi-cog" className="p-button-secondary" model={this.state.splitButtonMenu} ></SplitButton>;
    }

    toggleStockGroup = () => {
        var arr = this.state.selectedNodeKey.split('.');

        let expandedKeys = { ...this.state.expandedKeys };

        if (expandedKeys[arr[0]])
            delete expandedKeys[arr[0]];
        else
            expandedKeys[arr[0]] = true;

        this.setState({ expandedKeys: expandedKeys });
    }

    addParentStockGroup = () => {
        var arr = this.state.selectedNodeKey.split('.');

        this.setState({
            addModal2: true,
            stockGroupParentId: arr[0]  //seçili olanın id'si bu.
        });
    }

    addParentStockGroupOK = async () => {
        var response = await handleRequest("GET", "/StockGroup/" + this.state.stockGroupParentId);
        var item;

        if (response !== undefined || response !== null)
            item = response.data;

        var itemNew = {
            parentWillChangeId: this.state.stockGroupParentId,
            description: this.state.modalMaterialParentTypeName,
            parentId: item.parentId,
        }
  
        if(this.state.modalMaterialParentTypeName!=null && this.state.modalMaterialParentTypeName!=""){

        var responseAdd =  await handleRequest("POST", "/StockGroup/addParent", itemNew);

        if (responseAdd.data !== null && responseAdd.data !== undefined) {
            if (responseAdd.data == "SUCCESS") {
                this.setState({
                    addModal2: false
                });
        
                this.restartControls();
                this.restartTable();
            }
            else  {
                this.showError("An error was occured please try again later !");
            }  
          } 
          else  {
            this.showError("An error was occured please try again later !");
         } 
        } 
        else  {
            this.showError();
        }    
    }

    addChildStockGroup = () => {

        var arr = this.state.selectedNodeKey.split('.');

        this.setState({
            addModal: true,
            stockGroupParentId: arr[0]
        });
    }

    addChildStockGroupOK = async () => {
        var item = {
            parentId: this.state.stockGroupParentId,
            description: this.state.modalMaterialChildTypeName,
        } 
        if (this.state.stockGroupParentId != null && this.state.modalMaterialChildTypeName != null && this.state.modalMaterialChildTypeName != "") {
            var response =   await handleRequest("POST", "/StockGroup/add", item); 

            if (response.data !== null && response.data !== undefined) {
                if (response.data == "SUCCESS") {
                    this.setState({
                        addModal: false
                    });
            
                    this.showSuccess();
                    this.restartControls();
                    this.restartTable();
                }
                else   {
                    this.showError("An error was occured please try again later !");
                } 
              } 
              else {
                this.showError();
              }  
        }else {
            this.showError();
        }
    }

    editStockGroup = async () => {
        var arr = this.state.selectedNodeKey.split('.');

        var response = await handleRequest("GET", "/StockGroup/" + arr[0]);

        this.setState({
            editModal: true,
            stockGroupId: response.data.id,
            stockGroupParentId: response.data.parentId,
            modalEditStockGroupName: response.data.description
        });
    }

    editStockGroupOK = async () => {
        var item = {
            parentId: this.state.stockGroupParentId,
            id: this.state.stockGroupId,
            description: this.state.modalEditStockGroupName,
        }

        if (this.state.stockGroupId != null && this.state.modalEditStockGroupName != "") {
            
            var response = await handleRequest("POST", "/StockGroup/update", item);

            if (response.data !== null && response.data !== undefined) {
                if (response.data == "SUCCESS") {
                    this.setState({
                        editModal: false
                    });
            
                    this.showSuccess();
                    this.restartTable();
                    this.restartControls();
                }
                else   {
                    this.showError("An error was occured please try again later !");
                } 
              } 
            else {
                this.showError();
            }
        }else {
            this.showError();
        }
    }

    deleteStockGroup = () => {
        var arr = this.state.selectedNodeKey.split('.');

        this.setState({
            deleteModal: true,
            stockGroupId: arr[0]
        });
    }

    deleteStockGroupOK = async () => {
        const deletedItem = {
            id: this.state.stockGroupId
        } 

        var response = await handleRequest("POST", "/StockGroup/delete", deletedItem);

        if (response.data !== null && response.data !== undefined) {
            if (response.data == "SUCCESS") {
                this.setState({
                    deleteModal: false
                });
        
                this.restartControls();
                this.restartTable();
            }
            else   {
                this.showError("An error was occured please try again later !");
            } 
          } 
          else {
            this.showError();
          }
    }

    showOrHideModalDeleteStockGroup = () => {
        this.setState({
            deleteModal: !this.state.deleteModal
        });
    }

    showOrHideModalAddChildStockGroup = () => {
        this.setState({
            addModal: !this.state.addModal
        });
    }

    showOrHideModalAddParentStockGroup = () => {
        this.setState({
            addModal2: !this.state.addModal2
        });
    }

    showOrHideModalEditStockGroup = () => {
        this.setState({
            editModal: !this.state.editModal
        });
    }

    saveStockGroup = async () => { 
        if (this.state.stockGroupId === null && this.state.rootStockGroupName !== "") {
            var item = {
                parentId:0,  //Root Stock Group 
                description: this.state.rootStockGroupName,
            } 

            var response = await handleRequest("POST", "/StockGroup/add", item); 

            if (response.data !== null && response.data !== undefined) {
                if (response.data == "SUCCESS") {
                    this.showSuccess();

                    this.restartTable();
                    this.restartControls();
                }
                else   {
                    this.showError("An error was occured please try again later !");
                } 
              } 
              else {
                this.showError();
              }
 
        }else {
            this.showError();
        } 
    }

    showSuccess() {
        this.toast.show({ severity: 'success', summary: 'Success Message', detail: 'Successful.' });
      };
    
      showError(msg) {
        if (!msg) {
          msg = 'Something went wrong. Please check inputs.';
        }
        this.toast.show({ severity: 'error', summary: 'Error Message', detail: msg });
      };

    restartControls = () => {
        this.setState({
            stockGroupId: null,
            stockGroupParentId: null,
            rootStockGroupName: "",
            modalMaterialChildTypeName: "",
            modalMaterialParentTypeName:"",
            modalEditStockGroupName: ""
        });
    }

    handleSplitMenuChange = e => {
        this.setState({ selectedNodeKey: e.value });
    };

    render() {
        let actionHeader = <PrimeButton type="button" icon="pi pi-cog"></PrimeButton>;

        let header = <div style={{ 'textAlign': 'left' }}>
            <i className="pi pi-search" style={{ margin: '4px 4px 0 0' }}></i>
            <InputText type="search" onInput={(e) => this.setState({ globalFilter: e.target.value })} placeholder="Global Search" size="50" />
        </div>;

        return (
            <div>
                <Modal
                    show={this.state.deleteModal}
                    onHide={this.showOrHideModalDeleteStockGroup}
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter">Delete Stock Group</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p style={{ textAlign: 'center', color: 'black' }}>
                            Do you want to delete this Stock Group?
                    </p>
                        <p style={{ textAlign: 'center', color: 'black' }}>
                            This process will delete all related types.
                    </p>
                    </Modal.Body>
                    <Modal.Footer>
                        <ReactButton variant="secondary" onClick={this.showOrHideModalDeleteStockGroup}>Close</ReactButton>
                        <ReactButton variant="danger" onClick={this.deleteStockGroupOK}>Delete</ReactButton>
                    </Modal.Footer>
                </Modal>

                <Modal
                    show={this.state.addModal}
                    onHide={this.showOrHideModalAddChildStockGroup}
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter">Add Child Stock Group</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form style={{ marginTop: '2rem' }}>
                            <Form.Row>
                                <Form.Group as={Col} controlId="formGridCity">
                                    <Form.Label style={{ marginTop: '0.5rem' }}>Child Stock Group Name:</Form.Label>
                                </Form.Group>

                                <Form.Group as={Col} controlId="formGridCity">
                                    <InputText onChange={(e) => this.setState({ modalMaterialChildTypeName: e.target.value })}
                                        value={this.state.modalMaterialChildTypeName} placeholder="Stock Group Name" />
                                </Form.Group>
                            </Form.Row>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <ReactButton variant="secondary" onClick={this.showOrHideModalAddChildStockGroup}>Close</ReactButton>
                        <ReactButton variant="success" onClick={this.addChildStockGroupOK}>Add</ReactButton>
                    </Modal.Footer>
                </Modal>

                <Modal
                    show={this.state.addModal2}
                    onHide={this.showOrHideModalAddParentStockGroup}
                    aria-labelledby="contained-modal-title-vcenter"
                    centered>
                        
                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter">Add Parent Stock Group</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form style={{ marginTop: '2rem' }}>
                            <Form.Row>
                                <Form.Group as={Col} controlId="formGridCity">
                                    <Form.Label style={{ marginTop: '0.5rem' }}>Parent Stock Group Name:</Form.Label>
                                </Form.Group>

                                <Form.Group as={Col} controlId="formGridCity">
                                    <InputText onChange={(e) => this.setState({ modalMaterialParentTypeName: e.target.value })}
                                        value={this.state.modalMaterialParentTypeName} placeholder="Stock Group Name" />
                                </Form.Group>
                            </Form.Row> 
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <ReactButton variant="secondary" onClick={this.showOrHideModalAddParentStockGroup}>Close</ReactButton>
                        <ReactButton variant="success" onClick={this.addParentStockGroupOK}>Add</ReactButton>
                    </Modal.Footer>
                </Modal> 

                <Modal
                    show={this.state.editModal}
                    onHide={this.showOrHideModalEditStockGroup}
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter">Edit Stock Group</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form style={{ marginTop: '2rem' }}>
                            <Form.Row>
                                <Form.Group as={Col} controlId="formGridCity">
                                    <Form.Label style={{ marginTop: '0.5rem' }}>Stock Group Name:</Form.Label>
                                </Form.Group>

                                <Form.Group as={Col} controlId="formGridCity">
                                    <InputText onChange={(e) => this.setState({ modalEditStockGroupName: e.target.value })}
                                        value={this.state.modalEditStockGroupName} placeholder="Stock Group Name" />
                                </Form.Group>
                            </Form.Row>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <ReactButton variant="secondary" onClick={this.showOrHideModalEditStockGroup}>Close</ReactButton>
                        <ReactButton variant="success" onClick={this.editStockGroupOK}>Save</ReactButton>
                    </Modal.Footer>
                </Modal>
 
                <Card style={{ backgroundColor: "white", width: '700px' }}> 
                    <div className="content-section implementation">
                        <div style={{ backgroundColor: "white", padding: "10px" }} hidden={this.state.hidden} >
                            <div className="p-grid p-fluid">
                                  <div className="p-col-12">
                                        <form>
                                            <Form.Group style={{ marginBottom: '1rem' }} as={Row} controlId="formGridStockGroup">
                                                <Form.Label style={{ marginTop: '0.5rem', fontWeight: 'bold', fontSize: '15px' }}>Stock Group Name:</Form.Label>
                                                <Col sm="4">
                                                <InputText style={{ marginTop: '0.2rem', width: '100%' }} onChange={(e) => this.setState({ rootStockGroupName: e.target.value })} value={this.state.rootStockGroupName} placeholder="Stock Group Name" />
                                                </Col>
                                              <Col sm="4">
                                                 <ReactButton type="button" style={{ width: '100%' }} onClick={this.saveStockGroup} variant="info">Add to Root</ReactButton>
                                                </Col>
                                            </Form.Group>
                                        </form>
                                    </div>              
                                </div>  
                        </div>

                        <ContextMenu model={this.state.splitButtonMenu2} ref={el => this.cm = el} onHide={() => this.setState({ selectedNodeKey: null })} />
                        <Toast ref={(el) => this.toast = el}></Toast>
                        <TreeTable value={this.state.nodes} expandedKeys={this.state.expandedKeys} emptyMessage="No Stock Groups Found"
                            selectionMode="single" selectionKeys={this.state.selectedNodeKey} onSelectionChange={this.handleSplitMenuChange}
                            onToggle={e => this.setState({ expandedKeys: e.value })} globalFilter={this.state.globalFilter} header={header}
                            contextMenuSelection={this.state.selectedNodeKey} onContextMenuSelectionChange={e => this.setState({ selectedNodeKey: e.value })}
                            onContextMenu={e => this.cm.show(e.originalEvent)}>
                            <Column field="description" header="Stock Group" bodyStyle={{ fontWeight: 'bold' }} expander />
                        </TreeTable>
                    </div>
                </Card>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        i18n: state.i18n,
        auth: state.auth
    }
}

const mapDispatchToProps = {
}

export default connect(mapStateToProps, mapDispatchToProps)(StockGroup)